import React from 'react'
import { useStateAuthContext, useStateHostContext } from '../context';
import { FaCarAlt, FaFile, FaFilePdf, FaPrint } from 'react-icons/fa';
import { BeatLoader } from 'react-spinners';
import { error } from '../notify';
import { Document, Page, Text, View, StyleSheet, pdf } from '@react-pdf/renderer';
const Admin_kendaraan_mutasi = () => {
  window.document.title = "Kendaraan mutasi"

  const { HOST } = useStateHostContext();
  const { STATE_AUTH } = useStateAuthContext();

  const [data_kendaraan, set_kendaraan] = React.useState([])
  const [loading, set_loading] = React.useState(false)
  const [selectedYear, setSelectedYear] = React.useState('all')
  const [availableYears, setAvailableYears] = React.useState([])

  const handleGetDataKendaraan = React.useCallback(async () => {
    set_loading(true)
    try {
      const request = await fetch(HOST + '/admin/kendaraan/mutasi', {
        method: 'GET',
        headers: {
          'REST-TOKEN': STATE_AUTH.token
        }
      })
      const response = await request.json()
      if (request.ok) {
        if (response.s) {
          const data = response.d;
          set_kendaraan(data)
          
          // Extract unique years from transaction dates
          const years = [...new Set(data.map(item => new Date(item.tgl_transaksi).getFullYear()))].sort((a, b) => b - a);
          setAvailableYears(years);
          
          set_loading(false)
        } else {
          error({ msg: response.m })
          set_loading(false)
        }
      } else {
        set_loading(false)
        throw new Error(response.m);
      }
    } catch (error) {
      error({ msg: error.message })
      set_loading(false)
    }
  }, [HOST, STATE_AUTH])

  function formatTanggal(tanggalString) {
    // Ubah string ke objek Date
    const date = new Date(tanggalString);

    // Ambil bagian tanggal, bulan, dan tahun
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // bulan dimulai dari 0
    const year = date.getFullYear();

    // Gabungkan jadi format DD/MM/YYYY
    return `${day}/${month}/${year}`;
  }

  // Filter data based on selected year
  const filteredData = selectedYear === 'all'
    ? data_kendaraan
    : data_kendaraan.filter(item => new Date(item.tgl_transaksi).getFullYear() === parseInt(selectedYear));

  // PDF Styles
  const styles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      backgroundColor: '#ffffff',
      padding: 20,
    },
    title: {
      fontSize: 18,
      textAlign: 'center',
      marginBottom: 20,
      fontWeight: 'bold',
    },
    table: {
      display: 'table',
      width: 'auto',
      borderStyle: 'solid',
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    tableRow: {
      margin: 'auto',
      flexDirection: 'row',
    },
    tableColNo: {
      width: '4%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableColNama: {
      width: '25%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableColMerk: {
      width: '15%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableColOpdSebelum: {
      width: '20%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableColOpdSesudah: {
      width: '20%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableColTanggal: {
      width: '16%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCell: {
      margin: 2,
      fontSize: 8,
      textAlign: 'left',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    tableCellHeader: {
      margin: 2,
      padding: 2,
      fontSize: 9,
      fontWeight: 'bold',
      textAlign: 'left',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
    },
  });

  // PDF Document Component
  const MyDocument = ({ data, year }) => (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>Laporan Kendaraan Mutasi {year === 'all' ? 'Semua Tahun' : `Tahun ${year}`}</Text>
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.tableColNo}>
              <Text style={styles.tableCellHeader}>No</Text>
            </View>
            <View style={styles.tableColNama}>
              <Text style={styles.tableCellHeader}>Nama Kendaraan</Text>
            </View>
            <View style={styles.tableColMerk}>
              <Text style={styles.tableCellHeader}>Merk Type</Text>
            </View>
            <View style={styles.tableColOpdSebelum}>
              <Text style={styles.tableCellHeader}>OPD Sebelum</Text>
            </View>
            <View style={styles.tableColOpdSesudah}>
              <Text style={styles.tableCellHeader}>OPD Sesudah</Text>
            </View>
            <View style={styles.tableColTanggal}>
              <Text style={styles.tableCellHeader}>Tanggal Transaksi</Text>
            </View>
          </View>
          {data.map((item, index) => (
            <View style={[styles.tableRow, index % 2 === 0 ? { backgroundColor: '#f2f2f2' } : {}]} key={index}>
              <View style={styles.tableColNo}>
                <Text style={styles.tableCell}>{index + 1}</Text>
              </View>
              <View style={styles.tableColNama}>
                <Text style={styles.tableCell}>{item.nama_barang}</Text>
                <Text style={styles.tableCell}>({item.kode_barang})</Text>
              </View>
              <View style={styles.tableColMerk}>
                <Text style={styles.tableCell}>{item.merk_type}</Text>
              </View>
              <View style={styles.tableColOpdSebelum}>
                <Text style={styles.tableCell}>{item.opd_sebelum}</Text>
              </View>
              <View style={styles.tableColOpdSesudah}>
                <Text style={styles.tableCell}>{item.opd_sesudah}</Text>
              </View>
              <View style={styles.tableColTanggal}>
                <Text style={styles.tableCell}>{formatTanggal(item.tgl_transaksi)}</Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );

  // Function to generate and download PDF
  const generatePDF = async () => {
    const blob = await pdf(<MyDocument data={filteredData} year={selectedYear} />).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `laporan_kendaraan_mutasi_${selectedYear}.pdf`;
    link.click();
    URL.revokeObjectURL(url);
  };

  React.useEffect(() => {
    handleGetDataKendaraan()
  }, [handleGetDataKendaraan])


  return (
    <main>
      <div className="container-fluid mt-3">
        <div className="row mt-3">
          <div className="col-md-12">
            <h3><strong><FaCarAlt /> KENDARAAN MUTASI</strong></h3>
          </div>
        </div>
        <hr />
        {/* Filter Section */}
        <div className="row mb-3">
          <div className="col-md-3">
            <label htmlFor="tahunFilter" className="form-label">Filter Tahun:</label>
            <select
              id="tahunFilter"
              className="form-control form-control-sm"
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              <option value="all">Semua Tahun</option>
              {availableYears.map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label">&nbsp;</label>
            <button
              className="btn btn-primary btn-sm form-control"
              onClick={generatePDF}
              disabled={filteredData.length === 0}
            >
              <FaFilePdf className="me-1" /> Export PDF
            </button>
          </div>
        </div>
        <div className="row mt-2">
          <div class="col-md-12">
            {
              loading ?
                <div className="text-center">
                  <BeatLoader
                    size={15}
                  />
                </div>
                :
                <div className="table-responsive">
                  <table className='tb-daftar-dinas mt-1' >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Nama Kendaraan</th>
                        <th>Merk Type</th>
                        <th>OPD Sebelum</th>
                        <th>OPD Sesudah</th>
                        <th>Tanggal Mutasi</th>
                        <th>File BAST</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        filteredData.length > 0 ?
                          filteredData.map((val, index) => {
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  {val.nama_barang} <br />
                                  <small className='text-muted'>{val.kode_barang}</small>
                                </td>
                                <td>{val.merk_type}</td>
                                <td>{val.opd_sebelum}</td>
                                <td>{val.opd_sesudah}</td>
                                <td>{formatTanggal(val.tgl_transaksi)}</td>
                                <td>
                                  <div className='btn-group' role="group" aria-label="Basic example" >
                                    <button
                                      className='btn btn-sm btn-info'
                                      onClick={() => window.open(`${val.file_bast_mutasi}`, '_blank')}><FaFile className='me-1' size={15} />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            )
                          })
                          :
                          <tr>
                            <td colSpan={6} className="text-center">Tidak ada data</td>
                          </tr>
                      }
                    </tbody>
                  </table>
                </div>
            }
          </div>
        </div>
      </div>
    </main>
  )
}

export default Admin_kendaraan_mutasi;